import assignmentIdMethods from './assignments.id'
import assignmentsPaginated from './assignments.paginated'

export const AssignmentsOfReportServices = {
  id: assignmentIdMethods,
  paginated: assignmentsPaginated
}

export * from './assignments.types'
